<button mat-icon-button [cdkCopyToClipboard]="value || ''" (click)="copied()">
  <ng-content></ng-content>
  <fa-icon [icon]="copyIcon" size="xs"></fa-icon>
</button>
